module.exports = __webpack_public_path__ + "static/media/Bread-removebg-preview.ee8bd714.png";